import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const getDonationTPApi = async (donationTP: string, url: string): Promise<any> => {
  const token = cookies.get('authToken')
  try {
    const response = await axios.get(`${url}/donationtypepurpose/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const addDonationTPApi = async (
  Type: string,
  Purpose: string,
  url: string
) => {
  const token = cookies.get('authToken');
  const data = {
    DonationTypeId: Type ,
    DonationPurposeId: Purpose,
  };
  try {
    const response = await axios.post(
      `${url}/donationtypepurpose/create`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDonationTPApi = async (
  donationTypeId: string,
  donationPurposeId: string,
  url: string
) => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.request({
      method: 'DELETE',
      url: `${url}/donationtypepurpose/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        donationTypeId: donationTypeId ,
        donationPurposeId: donationPurposeId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
